import { h } from 'preact';
import register from '@wcd/preact-custom-element';
import { TESCookieV2 } from './cookies';

export const UserName = () => {
  const { username } = TESCookieV2() || {};

  const name = username;
  
  if (name) {
    return <span>{name}</span>;
  }

  return null;
};

register(UserName, 'tes-user-name', [], { shadow: false });
